<script setup>
  import { computed, onMounted, ref, useTemplateRef } from 'vue'
  import { useMediaQuery } from '@vueuse/core'

  const isActive = ref(false)
  const stepListWrapper = useTemplateRef('stepListWrapper')
  const isLargeScreen = useMediaQuery('(min-width: 1024px)')

  const props = defineProps({
    index: Number,
    item: Object
  })

  onMounted(() => {
    if (isLargeScreen.value) {
      isActive.value = true
    }

    if (props.index === 0) {
      isActive.value = true
    }
  })

  const realIndex = computed(() => {
    return props.index + 1
  })

  const wrapperHeight = computed(() => {
    if (!stepListWrapper.value) return

    if (!isActive.value && !isLargeScreen.value) {
      return 0
    }

    return stepListWrapper.value.scrollHeight + 20
  })
</script>

<template>
  <div
    class="step-list-item grid grid-cols-12 mb-20"
  >
    <div class="step-list-item-number -mt-3 lg:mt-0 col-span-2 lg:col-span-1 ~text-4xl/6xl text-body opacity-60">
      {{ realIndex }}
    </div>
    <div
        class="step-list-item-headline col-span-5 hidden lg:block ~text-lg/2xl mb-3 text-headline"
        v-html="item.headline"
    />
    <div
      class="step-list-item-details col-span-8 lg:col-span-6"
    >
      <div
        class="mobile-headline flex lg:hidden flex-row items-center justify-between ~text-lg mb-3 text-headline"
        @click="isActive = !isActive"
      >
        <span
          v-html="item.headline"
        />
        <AppIcon
          name="Chevron"
          class="transition-transform duration-500 ease-in-out"
          :class="{ 'rotate-180': isActive }"
        />
      </div>
      <div
        class="step-list-item-body overflow-hidden transition-all duration-500 ease-in-out"
        ref="stepListWrapper"
        :style="{ maxHeight: `${wrapperHeight}px` }"
      >
        <div
          class="details"
          v-html="item.text"
        />
        <div
          class="details-tags flex flex-row items-center gap-6 mt-6"
          v-if="item.day && item.duration"
        >
          <span
            class="flex flex-row w-fit items-center uppercase border text-headline border-body py-3 px-4 rounded-full ~text-xs/sm"
          >
            <AppIcon
              class="mr-2"
              name="Calendar"
            />
            {{ `Tag ${item.day}` }}
          </span>
          <span
            class="flex flex-row w-fit items-center uppercase border text-headline border-body py-3 px-4 rounded-full ~text-xs/sm"
          >
            <AppIcon
              class="mr-2"
              name="Clock"
            />
            {{ item.duration }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .details-tags :deep(svg) {
    @apply h-4 w-4;
  }
  .step-list-item-details :deep(p) {
    @apply mt-4 lg:mt-0;
  }
  .mobile-headline {
    :deep(svg) {
      @apply h-4 w-4;
    }
  }
</style>
